import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2025 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">AI / Software Engineer</h3>
            <h4 className="vertical-timeline-element-subtitle">BrahmaTron Matrix — Startup</h4>
            <p>
              Built end-to-end AI solutions using LLMs and backend services while collaborating in a fast-paced startup to deliver scalable products.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - 2026"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Quantum Algorithm Development Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">QuEdX Private Limited</h4>
            <p>
              Developed and analyzed quantum algorithms under industry mentorship, gaining practical exposure to research-driven quantum computing.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Edunet Foundation Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Mirosoft Azure</h4>
            <p>
             Trained under Edunet Foundation’s Internship Program in partnership with Microsoft Azure, gaining hands-on experience in cloud and AI technologies.
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">10xDev Club Member</h3>
            <h4 className="vertical-timeline-element-subtitle">DIET</h4>
            <p>
              Active member of the 10X DevOps Club at DIET, specializing in the Cybersecurity domain.
            </p>
          </VerticalTimelineElement> 
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;